import { useRef, useState } from "react";
import { labelsList, langGroup, msgType } from "../data/loginData";
import { strLang } from "../functions/strLang";
import { lang } from "../data/lang";
import { sendPostServices } from "../services/services";
import { getCurrentDate } from "../utilities/getCurrentDate";
import axios from "axios";
import { emptys, user } from "../data/main";
import StdButton from "../components/StdButton";
import { colorsList } from "../data/colorsList";
import StdInput from "../components/StdInput";

const writeLoginData = (code = false) => {
  let tempData = {};
  labelsList.forEach((e) => {
    tempData[e] = code ? lang[code][e] : strLang(e);
  });
  return tempData;
};

export default function useLogin({ login }) {
  const [mlang, setMLang] = useState(localStorage.getItem("lang"));
  const [initWords, setInitWords] = useState(writeLoginData());
  const [avatar, setAvatar] = useState(Number(localStorage.getItem("avatar")));
  const [open, setOpen] = useState(false);

  const [guser, setGUser] = useState(
    localStorage.getItem("name") ? localStorage.getItem("name") : "",
  );
  const [gcode, setGCode] = useState(
    localStorage.getItem("code") ? localStorage.getItem("code") : "",
  );

  const name = useRef();
  const group = useRef();
  const password = useRef();
  // const policy = useRef();

  const updateStatus = (code) => {
    setMLang(code);
    setInitWords(writeLoginData(code));
  };

  const inputList = [
    {
      ref: name,
      placeholder: initWords.initName,
      value: guser,
      change: (e) => setGUser(e.target.value),
    },
    {
      ref: group,
      placeholder: initWords.initCode,
      value: gcode,
      change: (e) => setGCode(e.target.value),
    },
    {
      ref: password,
      placeholder: initWords.initPassword,
      type: "password",
    },
  ];

  const writeInfo = (responseCheckCredentials, thisDate) => {
    if (group.current.value.trim() !== localStorage.getItem("group")) {
      localStorage.removeItem("mapid");
      localStorage.removeItem("menu");
    }

    localStorage.setItem("avatar", avatar);
    localStorage.setItem("lang", mlang);
    localStorage.setItem("group", group.current.value.trim());
    user.tile = emptys.includes(responseCheckCredentials.tile)
      ? "OSM"
      : responseCheckCredentials.tile;
    localStorage.setItem("tile", user.tile);
    localStorage.setItem("name", name.current.value.trim());
    localStorage.setItem("id", Number(responseCheckCredentials.id));
    localStorage.setItem("code", Number(responseCheckCredentials.code));
    localStorage.setItem("code2", Number(responseCheckCredentials.code2));
    localStorage.setItem("rol", Number(responseCheckCredentials.rol));
    localStorage.setItem("day", thisDate);
    localStorage.setItem("token", responseCheckCredentials.token);
    localStorage.setItem("logged", "true");
    if (responseCheckCredentials.activity_code) {
      localStorage.setItem(
        "activityCode",
        responseCheckCredentials.activity_code,
      );
    } else {
      localStorage.removeItem("activityCode");
    }

    if (Number(responseCheckCredentials.rol) > 0) {
      localStorage.setItem("groupName", responseCheckCredentials.groupName);
      localStorage.setItem("email", responseCheckCredentials.email);
    }

    login();
  };

  const checkCredentials = async () => {
    let responseCheckCredentials = false;
    let thisDate = false;
    let errorMsg = false;
    let missField = !avatar
      ? initWords.avatar
      : !mlang
        ? "language"
        : name.current.value.trim() === ""
          ? initWords.initName
          : group.current.value.trim() === ""
            ? initWords.initCode
            : password.current.value.trim() === ""
              ? initWords.initPassword
              : false;

    if (missField) {
      errorMsg = initWords.pleaseSelect + missField;
    } else {
      setOpen("loading");
      let userInfo = {};
      try {
        await axios.get("https://ipapi.co/json/").then((res) => {
          userInfo = {
            ip: res.data.ip,
            country: res.data.country_code,
          };
        });
      } catch (error) {
        console.log("ip error: ", error);
      }

      thisDate = getCurrentDate();

      let payloadCheckCredentials = {
        type: "login",
        avatar: avatar,
        code: group.current.value.trim(),
        name: name.current.value.trim(),
        password: password.current.value.trim(),
        date: thisDate,
        country: userInfo.country,
        ip: userInfo.ip,
      };
      // console.log(payloadCheckCredentials);

      responseCheckCredentials = await sendPostServices(
        payloadCheckCredentials,
      );
      // console.log(responseCheckCredentials);

      password.current.value = "";

      errorMsg = responseCheckCredentials.restricted_zone
        ? initWords.accessRestricted
        : responseCheckCredentials.inactive
          ? initWords.inactive
          : responseCheckCredentials.netWorkError
            ? initWords.netWorkError
            : !responseCheckCredentials.status
              ? initWords.badCredentials
              : false;
    }

    if (errorMsg) {
      msgType[responseCheckCredentials ? "error" : "warning"].label = errorMsg;
      setOpen(responseCheckCredentials ? "error" : "warning");
    } else {
      writeInfo(responseCheckCredentials, thisDate);
    }
  };

  const writeLangButtons = () =>
    langGroup.map((o, index) => (
      <StdButton
        key={index}
        onClick={() => {
          updateStatus(o.code);
        }}
        label={o.name}
        color={mlang === o.code ? colorsList.blue : colorsList.darkGrey}
        width={60}
      />
    ));

  const inputGroup = () =>
    inputList.map((input, index) => (
      <StdInput
        key={index}
        refId={input.ref}
        placeholder={input.placeholder}
        value={input.value}
        change={input.change}
        type={input.type}
      />
    ));

  const closeMsg = () => {
    setOpen(false);
  };

  return {
    mlang,
    setMLang,
    avatar,
    setAvatar,
    writeLoginData,
    initWords,
    setInitWords,
    updateStatus,
    inputList,
    checkCredentials,
    writeLangButtons,
    inputGroup,
    open,
    closeMsg,
    msgType,
  };
}
